import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatThemeColor } from '../../enums/mat-theme-color';
import {
    ConfirmationModalAction,
    ConfirmationModalModel,
} from '../../models/confirmation-modal-model';
import { SharedDialogShellConfig } from '../../models/shared-dialog-shell-config';
import { SharedDialogShellComponent } from '../shared-dialog-shell/shared-dialog-shell.component';

@Component({
    selector: 'apcam-confirmation',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss'],
    imports: [
        MatButtonModule,
        MatIconModule,
        SharedDialogShellComponent,
        TranslatePipe,
    ],
})
export class ConfirmationDialogComponent {
    protected get dialogShellConfig(): SharedDialogShellConfig<ConfirmationModalAction> {
        return {
            title: this.data.summary,
            cancelLabel: this.translateService.instant('shared.buttons.reject'),
            cancelIcon: 'cancel',
            confirmLabel: this.translateService.instant(
                'shared.buttons.confirm'
            ),
            confirmIcon: 'check',
            onCancel: () =>
                this.dialogRef.close(ConfirmationModalAction.REJECT),
            onConfirm: () => ConfirmationModalAction.CONFIRM,
        };
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) protected data: ConfirmationModalModel,
        private readonly dialogRef: MatDialogRef<ConfirmationDialogComponent>,
        private readonly translateService: TranslateService
    ) {}

    protected readonly iconColor = this.data.iconColor ?? MatThemeColor.WARN;

    /** `detail` may be a single paragraph or several; normalized once so the template renders one loop. */
    protected readonly paragraphs = Array.isArray(this.data.detail)
        ? this.data.detail
        : [this.data.detail];
}
